import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlloyButton } from 'cat-ecommerce-alloy';
import { replaceTokensInString } from '@app/utils';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { stopEditQuote } from '@app/store/account/actions';
import { useAnalytics } from '@app/hooks';
import { getGACheckoutProducts } from '@app/hooks/useAnalytics/utils';

const StopEditingQuote = ({
  originalQuoteNumber,
  originalQuoteId,
  orderId
}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { fireRemoveFromCartEvent } = useAnalytics();

  const products = useSelector(
    s => s.orders?.byId?.[orderId]?.ascendingOrderItems || []
  );
  const emailCart = useSelector(s => s.common.emailCart);
  const dealerStore = useSelector(s => s.common?.storeLocationName) ?? '';

  const redirectLink = async () => {
    await dispatch(stopEditQuote(originalQuoteId));
    const gaItems = getGACheckoutProducts({ products, emailCart });
    fireRemoveFromCartEvent({ products: gaItems, dealerStore });
  };

  return (
    <div className="text-sans-serif d-flex mb-2 mb-lg-1">
      <span className="u-color--DarkGray u-fs--14 u-fs-sm--16 fw-bold p-0 m-0">
        {replaceTokensInString(t('EDITING_QUOTE'), originalQuoteNumber)}
      </span>
      <AlloyButton
        buttonType="link"
        size="large"
        className={cx('text-sans-serif text-xs p-0 ms-4')}
        onClick={redirectLink}
      >
        {t('STOP_EDITING')}
      </AlloyButton>
    </div>
  );
};

StopEditingQuote.propTypes = {
  originalQuoteNumber: PropTypes.string,
  originalQuoteId: PropTypes.string,
  orderId: PropTypes.string
};

export default StopEditingQuote;
